<template>
	<div v-if="student">
		<ja-button
			ref="tooltip-complete-life-stage"
			:aria-label="$t('moreMenu')"
			class="small transparent more-menu-btn"
			name="tooltip-complete-life-stage"
			@click.native="toggleTooltip(student.id)"
		>
			<svgicon class="more-menu" :original="true" name="more"></svgicon>
		</ja-button>
		<ja-tooltip
			v-show="openedTooltipIndex === student.id"
			v-click-outside="{
				handler: 'closeTooltip',
				exclude: ['tooltip-complete-life-stage']
			}"
			class="complete-lifestage-tooltip"
			:name="'select' + student.id"
		>
			<ja-button
				name="complete-life-stage"
				class="small transparent body-text-1 complete-life-stage-btn"
				:aria-label="$t('completeLifeStage')"
				@click.native="openConfirmationDialog(student)"
			>
				{{ $t('completeLifeStage') }}
			</ja-button>
		</ja-tooltip>
	</div>
</template>
<script>
import '../../icons/more';

import Tooltip from '@/components/ui/Tooltip';
import Button from '@/components/ui/Button';

export default {
	components: {
		jaTooltip: Tooltip,
		jaButton: Button
	},
	props: {
		student: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {
			openedTooltipIndex: null,
			selectedStudForLSComplition: null
		};
	},

	methods: {
		closeTooltip() {
			this.openedTooltipIndex = null;
		},
		toggleTooltip(index) {
			this.openedTooltipIndex =
				this.openedTooltipIndex === index ? null : index;
		},
		openConfirmationDialog(student) {
			this.$emit('openConfirmationDialog', student);
		}
	}
};
</script>
<style lang="scss" scoped>
.more-menu-btn {
	display: inline-block;
	max-width: 50px !important;
	min-width: 30px !important;
	height: auto;
	min-width: 0px;
	padding-left: 0px !important;
	padding-right: 0px !important;
	.small {
		padding-left: 0px;
		padding-right: 0px;
	}

	@media (any-hover: hover) {
		&:hover svg {
			fill: $hover-state;
			cursor: pointer;
		}
	}

	.svg-fill {
		height: 20px;
		width: 20px;
		fill: $primary-state !important;
		stroke: none !important;
	}

	.tooltip-msg {
		position: relative;
	}
}
.complete-lifestage-tooltip {
	width: max-content;
	height: 50px;
	right: -100px;
	position: absolute;
	margin-top: -47px;
	margin-right: 130px;

	.tooltip-pointer {
		z-index: -1;
	}

	.body-text-1 {
		display: flex;

		.complete-life-stage-btn {
			z-index: 1;
			margin-top: -13px;
			font-family: 'RobotoMedium';
		}
	}
}
</style>
